
import { AddChildDialog } from "@/components/AddChildDialog";
import { EditChildDialog } from "@/components/children/EditChildDialog";
import { DeleteChildDialog } from "@/components/children/DeleteChildDialog";
import { Database } from "@/types/supabase";

type Child = Database["public"]["Tables"]["children"]["Row"];

interface ChildrenDialogsProps {
  addDialogOpen: boolean;
  setAddDialogOpen: (open: boolean) => void;
  onChildAdded: (childId: string) => void;
  
  editDialogOpen: boolean;
  setEditDialogOpen: (open: boolean) => void;
  selectedChild: Child | null;
  onChildUpdated: (updatedChild: Child) => void;
  
  deleteDialogOpen: boolean;
  setDeleteDialogOpen: (open: boolean) => void;
  onConfirmDelete: () => void;
}

export function ChildrenDialogs({
  addDialogOpen,
  setAddDialogOpen,
  onChildAdded,
  
  editDialogOpen,
  setEditDialogOpen,
  selectedChild,
  onChildUpdated,
  
  deleteDialogOpen,
  setDeleteDialogOpen,
  onConfirmDelete
}: ChildrenDialogsProps) {
  return (
    <>
      <AddChildDialog
        open={addDialogOpen}
        onOpenChange={setAddDialogOpen}
        onSuccess={onChildAdded}
      />
      
      <EditChildDialog
        open={editDialogOpen}
        onOpenChange={setEditDialogOpen}
        selectedChild={selectedChild}
        onSave={onChildUpdated}
      />
      
      <DeleteChildDialog
        open={deleteDialogOpen}
        onOpenChange={setDeleteDialogOpen}
        selectedChild={selectedChild}
        onConfirm={onConfirmDelete}
      />
    </>
  );
}
